import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVkLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 14,
		r: 14,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.7145 19C9.24795 19 6.12993 15.2462 6 9H8.73829C8.82824 13.5846 10.8469 15.5265 12.4459 15.9269V9H15.0244V12.9539C16.6034 12.7838 18.2622 10.982 18.8218 9H21.4003C20.9705 11.4425 19.1717 13.2442 17.8925 13.985C19.1717 14.5856 21.2205 16.1571 22 19H19.1617C18.5521 17.0981 17.0331 15.6266 15.0244 15.4264V19H14.7145Z",
		fill: "#4469C6"
	})]
});
export default SvgVkLogo;
